export default __webpack_public_path__ + "static/insfocus_cover-small_1-fb6df6d5add13e532bcd2ceefa932c2e.png";